export default "__VITE_ASSET__BnOz8ZiE__"